"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.buildOptimisticOperation = exports.buildOptimisticTokenOperation = exports.buildOptimisticCoinOperation = void 0;
var eip55_1 = __importDefault(require("eip55"));
var operation_1 = require("../../operation");
var account_1 = require("../../account");
var logic_1 = require("./logic");
var bignumber_js_1 = __importDefault(require("bignumber.js"));
/**
 * Build an optimistic operation for the coin of the integration (e.g. Ether for Ethereum)
 */
var buildOptimisticCoinOperation = function (account, transaction, transactionType) {
    var type = transactionType !== null && transactionType !== void 0 ? transactionType : "OUT";
    var estimatedFees = (0, logic_1.getEstimatedFees)(transaction);
    var value = transaction.amount.plus(estimatedFees);
    // keys marked with a <-- will be updated by the broadcast method
    var operation = {
        id: (0, operation_1.encodeOperationId)(account.id, "", type),
        hash: "",
        type: type,
        value: value,
        fee: estimatedFees,
        blockHash: null,
        blockHeight: null,
        senders: [eip55_1["default"].encode(account.freshAddress)],
        recipients: [eip55_1["default"].encode(transaction.recipient)],
        accountId: account.id,
        transactionSequenceNumber: transaction.nonce,
        date: new Date(),
        extra: {}
    };
    return operation;
};
exports.buildOptimisticCoinOperation = buildOptimisticCoinOperation;
/**
 * Build an optimistic operation for an ERC20 transaction
 */
var buildOptimisticTokenOperation = function (account, tokenAccount, transaction) {
    var type = "OUT";
    var estimatedFees = (0, logic_1.getEstimatedFees)(transaction);
    var value = transaction.useAllAmount
        ? tokenAccount.balance
        : transaction.amount;
    var coinOperation = (0, exports.buildOptimisticCoinOperation)(account, __assign(__assign({}, transaction), { recipient: tokenAccount.token.contractAddress, amount: new bignumber_js_1["default"](0) }), "FEES");
    // keys marked with a <-- will be updated by the broadcast method
    var operation = __assign(__assign({}, coinOperation), { subOperations: [
            {
                id: (0, operation_1.encodeOperationId)(tokenAccount.id, "", type),
                hash: "",
                type: type,
                value: value,
                fee: estimatedFees,
                blockHash: null,
                blockHeight: null,
                senders: [eip55_1["default"].encode(account.freshAddress)],
                recipients: [eip55_1["default"].encode(transaction.recipient)],
                accountId: tokenAccount.id,
                transactionSequenceNumber: transaction.nonce,
                date: new Date(),
                extra: {},
                contract: tokenAccount.token.contractAddress
            },
        ] });
    return operation;
};
exports.buildOptimisticTokenOperation = buildOptimisticTokenOperation;
/**
 * Create a temporary operation to use until it's confirmed by the blockchain
 */
var buildOptimisticOperation = function (account, transaction) {
    var subAccount = (0, account_1.findSubAccountById)(account, (transaction === null || transaction === void 0 ? void 0 : transaction.subAccountId) || "");
    var isTokenTransaction = (subAccount === null || subAccount === void 0 ? void 0 : subAccount.type) === "TokenAccount";
    return isTokenTransaction
        ? (0, exports.buildOptimisticTokenOperation)(account, subAccount, transaction)
        : (0, exports.buildOptimisticCoinOperation)(account, transaction);
};
exports.buildOptimisticOperation = buildOptimisticOperation;
exports["default"] = exports.buildOptimisticOperation;
//# sourceMappingURL=buildOptimisticOperation.js.map